<template>
    <div class="overflow-auto">
        <table class="my-4 mx-auto">
            <thead>
                <tr class="labels">
                    <th>{{ kpiPrefix }} Distance (<MeasurementUnit :type="LongDistance" />)</th>
                    <th>{{ kpiPrefix }} HSR (<MeasurementUnit :type="ShortDistance" />)</th>
                    <th>{{ kpiPrefix }} Sprint (<MeasurementUnit :type="ShortDistance" />)</th>
                    <th>{{ kpiPrefix }} Turns (n)</th>
                    <th>{{ kpiPrefix }} Acceleration (<MeasurementUnit :type="ShortDistance" />)</th>
                    <th>{{ kpiPrefix }} Deceleration (<MeasurementUnit :type="ShortDistance" />)</th>
                    <th>{{ kpiPrefix }} Peak Speed (<MeasurementUnit :type="PeakSpeed" />)</th>
                </tr>
                <tr class="labels" style="font-size: 10px;">
                    <td></td>
                    <td>Over <MeasurementValue :type="Speed" :value="5.5" /> <MeasurementUnit :type="Speed" /></td>
                    <td>Over <MeasurementValue :type="Speed" :value="7" /> <MeasurementUnit :type="Speed" /></td>
                    <td></td>
                    <td>Greater than <MeasurementValue :type="Acceleration" :value="2" :format="formatCoarse" />
                        <MeasurementUnit :type="Acceleration" /></td>
                    <td>Less than - <MeasurementValue :type="Acceleration" :value="2" :format="formatCoarse" />
                        <MeasurementUnit :type="Acceleration" /></td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.DISTANCE)"><h2><MeasurementValue :type="LongDistance" :value="kpiValues.DISTANCE" /></h2></td>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.HSR)"><h2><MeasurementValue :type="ShortDistance" :value="kpiValues.HSR" /></h2></td>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.SPRINT)"><h2><MeasurementValue :type="ShortDistance" :value="kpiValues.SPRINT" /></h2></td>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.TURNS)"><h2>{{ kpiValues.TURNS }}</h2></td>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.ACCEL)"><h2><MeasurementValue :type="Acceleration" :value="kpiValues.ACCEL" /></h2></td>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.DECEL)"><h2><MeasurementValue :type="Acceleration" :value="kpiValues.DECEL" /></h2></td>
                    <td v-b-tooltip.hover :title="getTooltip(maxValueDate.PEAK_SPEED)"><h2><MeasurementValue :type="PeakSpeed" :value="kpiValues.PEAK_SPEED" /></h2></td>
                </tr>
                <tr class="labels" style="font-size: 12px;">
                    <td>{{ getDisplayText(kpiValues.DISTANCE, kpiComparison.DISTANCE) }}</td>
                    <td>{{ getDisplayText(kpiValues.HSR, kpiComparison.HSR) }}</td>
                    <td>{{ getDisplayText(kpiValues.SPRINT, kpiComparison.SPRINT) }}</td>
                    <td>{{ getDisplayText(kpiValues.TURNS, kpiComparison.TURNS) }}</td>
                    <td>{{ getDisplayText(kpiValues.ACCEL, kpiComparison.ACCEL) }}</td>
                    <td>{{ getDisplayText(kpiValues.DECEL, kpiComparison.DECEL) }}</td>
                    <td>{{ getPeakSpeedDisplayText(kpiValues.PEAK_SPEED, kpiComparison.PEAK_SPEED) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import MeasurementUnit from "@/components/MeasurementUnit.vue";
import MeasurementValue from "@/components/MeasurementValue.vue";
import { MeasurementTypes, MeasurementUnit as MU } from "@/utils/MeasurementSystem";

export default {
    data() {
        return {
            Acceleration: MeasurementTypes.Acceleration,
            ShortDistance: MeasurementTypes.ShortDistance,
            LongDistance: MeasurementTypes.LongDistance,
            PeakSpeed: MeasurementTypes.PeakSpeed,
            Speed: MeasurementTypes.Speed,
            formatCoarse: MU.prototype.formatCoarse,
        };
    },
    props: {
        kpiValues: Object,
        kpiComparison: Object,
        valueLabel: String,
        kpiPrefix: {
            type: String,
            default: ""
        },
        peakSpeedLabel: String,
        maxValueDate: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        MeasurementUnit,
        MeasurementValue
    },
    methods: {
        getDisplayText(kpi, comparisonValue) {
                if (kpi !== null && comparisonValue !== null) {
                    return `${this.calculatePercentageCap(kpi, comparisonValue)}% of ${this.valueLabel}`;
                } else {
                    return '-';
            }
        },
        getPeakSpeedDisplayText(kpi, comparisonValue) {
            if (this.peakSpeedLabel) {
                if (kpi === null || kpi === undefined) return "-";
                return `${this.calculatePercentageCap(kpi, comparisonValue)}% of ${this.peakSpeedLabel}`;
            }
            return this.getDisplayText(kpi, comparisonValue);
        },
        calculatePercentageCap(value, comparisonValue) {
            const percentage = ((value / comparisonValue) * 100).toFixed(0);
            return percentage >= 120 ? 120 : percentage; // percentages are capped at 120%
        },
        getTooltip(value) {
            return value ? 'Date: ' + value : null;
        }
    },
};
</script>

<style scoped>
.labels {
    color: var(--bg-secondary-light);
}
table {
    width: 60vw;
    border-collapse: collapse;
    white-space: nowrap;
}
th, td {
    padding: 0px 10px;
}
th:not(:last-child),
td:not(:last-child) {
    border-right: 1px solid var(--bg-secondary-dark);
}

th, td {
    min-width: 10vw;
    max-width: 20vw;
    overflow: hidden;
}

</style>